mutation UpdateTugOfWar(
  $tugId: ID!
  $name: String
  $broadcasterUserIds: [String!]
  $question: String
  $optionA: StreamToolsTugSideInput
  $optionB: StreamToolsTugSideInput
  $dedupe: Boolean
  $questionTextColor: String
  $finalizedText: String
  $finalizedTextColor: String
  $backgroundColor: String
  $chatCommandBackground: String
  $barHeight: Int
  $backgroundImage: String
  $backgroundImageFit: StreamToolsImageFit
  $cornerRadius: Int
  $borderWidth: Int
  $borderColor: String
  $fontKey: String
  $youtubeVotesEnabled: Boolean
) {
  tug: StreamToolsUpdateTugOfWar(
    tugId: $tugId
    name: $name
    broadcasterUserIds: $broadcasterUserIds
    question: $question
    optionA: $optionA
    optionB: $optionB
    dedupe: $dedupe
    questionTextColor: $questionTextColor
    finalizedText: $finalizedText
    finalizedTextColor: $finalizedTextColor
    backgroundColor: $backgroundColor
    chatCommandBackground: $chatCommandBackground
    barHeight: $barHeight
    backgroundImage: $backgroundImage
    backgroundImageFit: $backgroundImageFit
    cornerRadius: $cornerRadius
    borderWidth: $borderWidth
    borderColor: $borderColor
    fontKey: $fontKey
    youtubeVotesEnabled: $youtubeVotesEnabled
  ) {
    tugId
    eventId
    name
    broadcasterUserIds
    question
    status
    dedupe
    youtubeVotesEnabled
    totalVotes
    startedAt
    stoppedAt
    createdAt
    questionTextColor
    finalizedText
    finalizedTextColor
    backgroundColor
    chatCommandBackground
    barHeight
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    fontKey
    version
    optionA { displayText command voteCount voteCountByPlatform { twitch youtube } color textColor imageUrl }
    optionB { displayText command voteCount voteCountByPlatform { twitch youtube } color textColor imageUrl }
  }
}
